/* eslint-disable import/prefer-default-export */
export const zoomEnterprisePlans = [
  {
    type: 'ENTERPRISE',
    title: 'Essentials',
    seats: '10+ Seats',
    description: 'Collaboration-centric plan for hybrid work',
    features: [
      '<span class="text-[#295BF6] font-medium">500</span> Meeting Participants',
      '<span class="text-[#295BF6] font-medium">Unlimited</span> Cloud Storage',
      '<span class="text-[#295BF6] font-medium">Unlimited</span> Whiteboards',
      '<span class="text-[#295BF6] font-medium">AI Companion</span>',
      'Scheduler',
      'Automated Captions & <span class="text-[#295BF6] font-medium">Translations</span>',
      'Team Chat',
      'Mail, Calendar, Scheduler',
      '500 Webinar Atendees',
      'Workspace Reservation / Visitor Mgmt',
      'Productivity: Clips, Notes, Surveys',
      'Single Sign-On Security',
    ],
    additionalContent:
      '<div class="flex flex-col bg-[#295BF61A] p-2.5 rounded-[10px]"><p class="text-[10px]">Also Includes</p><p class="text-[8px]">Zoom Rooms <span class="font-medium text-[#295BF6]">(1:25)</span> Conference Room Connector <span class="font-medium text-[#295BF6]">(1:25)</span></p><p class="text-[8px]">Integrations with Microsoft, Google, Salesforce, Servicenow, and more</p></div>',
    ctaLink: 'https://s.zoom.us/m/bPFdGiEkl',
  },
  {
    type: 'ENTERPRISE',
    title: 'Plus',
    seats: '50+ Seats',
    description: 'Adds Zoom Phone, Whiteboards+, and Sessions',
    features: [
      '<span class="text-[#295BF6] font-medium">1,000</span> Meeting Participants',
      '<span class="text-[#295BF6] font-medium">1,000</span> Sessions Attendees',
      'Rooms & Conference Room Connector',
      '<span class="text-[#295BF6] font-medium">Phone</span> & Power Pack',
      'Common Area Phones',
      'Customer-Managed Key',
    ],
    additionalContent:
      '<div class="bg-[#295BF61A] p-2.5 flex items-center justify-center gap-[7px] rounded-[10px]"><p class="text-[10px]">Also Include everything in</p><div class="text-xs text-white text-center px-2.5 py-[2px] rounded-[10px] bg-[#3066D2]">Enterprise Essentials</div></div>',
    ctaLink: 'https://s.zoom.us/m/bPFdGiEkl',
  },
  {
    type: 'ENTERPRISE',
    title: 'Premier',
    seats: '50+ Seats',
    description: 'Adds Zoom Phone calling plan & Zoom Mesh',
    features: [
      '<span class="text-[#295BF6] font-medium">Unlimited</span> Zoom Phone Calling',
      '<span class="text-[#295BF6] font-medium">Mesh</span>',
      'Rooms <span class="text-[#295BF6] font-medium">(1:25)</span>',
      'Conference Room Connector <span class="text-[#295BF6] font-medium">(1:25)</span>',
    ],
    additionalContent:
      '<div class="bg-[#295BF61A] p-2.5 flex items-center justify-center gap-[7px] rounded-[10px]"><p class="text-[10px]">Also Include everything in</p><div class="text-xs text-white text-center px-2.5 py-[2px] rounded-[10px] bg-[#3066D2]">Enterprise Plus</div></div>',
    ctaLink: 'https://s.zoom.us/m/bPFdGiEkl',
  },
];
